import {
    Col,
    Row,
    Input,
    Form,
    Card,
    Collapse,
    Select,
    Button,
    DatePicker,
    Space,
    type DatePickerProps,
    Tooltip,
} from 'antd'
import commonStyles from '../../../../Utils/Common.less'
import soleTraderNewStyles from '../../../../Less/Clients/RegisteredClients/SoleTrader/SoleTraderNew.less'
import { connect, useDispatch } from 'react-redux'
import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { GetCategoryDropDownList } from '../../../../Services/GroupAndPartners'
import type { SoleTraderNewStateInterface } from '../../../../Types/Client/RegisteredClients/SoleTrader'
import { GetCountryList } from '../../../../Services/Common'
import { SaveOutlined } from '@ant-design/icons'
import { type IndividualCreateFormDataInterface } from '../../../../Types/Client/RegisteredClients/Individual'
import { saveInduvidual } from '../../../../Services/Individual'
import dayjs from 'dayjs'
import { validateDate } from '../../../../Utils/ValidateDate'
import { validateName } from '../../../../Utils/Common'
import PostCodeInput from '../../../../Components/PostCodeInput'
import { type ListFrontEndInterface } from '../../../../Types/CommonType'
import InputFieldNINumber from '../../../../Components/InputNINO'

const InduvidualNew = (
    props: SoleTraderNewStateInterface
): React.ReactElement => {
    const location = useLocation()
    const { categoryDropDownList, countryList } = props
    const onbordingId = location.state?.onbordingId
    const [form] = Form.useForm()
    const [collapseOne, SetCollapseOne] = useState<string[] | string>(['1'])
    const [collapseTwo, SetCollapseTwo] = useState<string[] | string>([])
    const navigate = useNavigate()
    const [selectedDate, setSelectedDate] = useState<string>('')
    const [selecteddueDate] = useState<string>('')
    const dispatch = useDispatch()
    const hasFetchedOnce = useRef(false)
    const [buttonLoading, setButtonLoading] = useState(false)
    const [address, setAddress] = useState({
        line_1: '',
        line_2: '',
        line_3: '',
        post_town: '',
        postcode: '',
        country: '',
    })
    useEffect(() => {
        const countryData = countryList?.find(
            (data: ListFrontEndInterface) =>
                data.label === address?.country?.toUpperCase()
        )
        if (address.line_1 !== '') {
            const AddressData = {
                homeTown: address.post_town,
                homeCountry: countryData?.label ?? '',
                homePostCode: address.postcode,
                addressOne: address?.line_1,
                addressTwo: address?.line_2,
            }
            form.setFieldsValue(AddressData)
        }
    }, [address])
    useEffect(() => {
        if (!hasFetchedOnce.current) {
            hasFetchedOnce.current = true
            return
        }
        GetCategoryDropDownList(dispatch)
        GetCountryList(dispatch)
    }, [dispatch, Form])

    const customizeRequiredMark = (
        label: React.ReactNode,
        { required }: { required: boolean }
    ): React.ReactElement => (
        <>
            {label}
            &nbsp;
            {required && <span className={commonStyles.requireIcon}>*</span>}
        </>
    )

    const saveCallBack = (data: IndividualCreateFormDataInterface): void => {
        const indData = {
            individualId: data?.individualId,
            name: `${data?.title} ${data?.firstName} ${data?.surName} ${data?.middleName}`,
            tradingName: data?.tradingName,
            typeOfSelfEmployment: data?.typeOfSelfEmployment,
            clientNumber: data.clientNumber,
            activestatus: data.isActive,
            mobilenumber: data.mobileNumber,
            emailAddress: data.emailAddress,
            alternativeEmailAddress: data.alternativeEmailAddress,
        }
        localStorage.setItem('individualTapId', '1')
        //  '/clients/registered-clients/individual-view'

        navigate(
            onbordingId === 1
                ? '/clients/registered-clients/individual-view'
                : '/clients/onboarding-clients/individual-view',
            {
                state: { individualData: indData, onbordingId },
            }
        )
    }

    const onsaveInduvidual = (
        data: IndividualCreateFormDataInterface
    ): void => {
        void onSaveSoleTrader(data)
    }
    const onSaveSoleTrader = async (
        data: IndividualCreateFormDataInterface
    ): Promise<void> => {
        try {
            await form.validateFields()
            setButtonLoading(true)
            await saveInduvidual(dispatch, data, saveCallBack).then(
                (result) => {
                    if (result !== null && result !== undefined) {
                        setButtonLoading(false)
                    }
                }
            )
        } catch (error: any) {}
    }

    const collapseOneOnChange = (data: string | string[]): void => {
        SetCollapseOne(data)
    }

    const collapseTwoOnChange = (data: string | string[]): void => {
        SetCollapseTwo(data)
    }

    const onChange = (
        dateOfBirth: DatePickerProps['value'],
        dateString: string | string[]
    ): void => {
        if (dateOfBirth != null) {
            const isoDate = dateOfBirth.toISOString()
            setSelectedDate(isoDate)
            form.setFieldValue('dateOfBirth', isoDate)
            void form.validateFields(['dateOfBirth'])
        }
    }

    useEffect(() => {
        form.setFieldValue('dateOfBirth', selectedDate)
        form.setFieldValue('dueDate', selecteddueDate)
    }, [selectedDate, selecteddueDate])
    const initialDetails = (): React.ReactElement => {
        return (
            <div>
                <Form.Item
                    label="Client Category"
                    name="clientCategoryId"
                    initialValue={1}
                    rules={[
                        {
                            required: true,
                            message: 'Please Select Client Category',
                        },
                    ]}
                >
                    <Select
                        placeholder="Please select"
                        options={[...categoryDropDownList]}
                        defaultValue={1}
                        filterOption={(input, option) =>
                            option?.label
                                ?.toLowerCase()
                                .includes(input.toLowerCase()) ?? false
                        }
                        allowClear
                        showSearch
                    />
                </Form.Item>
                <Form.Item label="Title" name="title">
                    <Select
                        allowClear
                        placeholder="Please select tittle"
                        onChange={() => {}}
                        defaultValue={'UNKNOWN'}
                    >
                        <Select.Option value="UNKNOWN">Unknown</Select.Option>
                        <Select.Option value="MR.">MR.</Select.Option>
                        <Select.Option value="MISS.">MISS.</Select.Option>
                        <Select.Option value="MRS.">MRS.</Select.Option>
                        <Select.Option value="MS.">MS.</Select.Option>
                        <Select.Option value="DR.">DR.</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    label="First Name"
                    name="firstName"
                    rules={[
                        {
                            required: true,
                            message: 'Please Enter First Name',
                        },
                        {
                            validator: async (rule, value) =>
                                await validateName(rule, value, 'First Name'),
                        },
                    ]}
                >
                    <Input allowClear maxLength={100} />
                </Form.Item>
                <Form.Item
                    label="Middle Name"
                    name="middleName"
                    rules={[
                        {
                            validator: async (rule, value) =>
                                await validateName(rule, value, 'Middle Name'),
                        },
                    ]}
                >
                    <Input allowClear maxLength={100} />
                </Form.Item>
                <Form.Item
                    label="Surname"
                    name="surName"
                    rules={[
                        {
                            required: true,
                            message: 'Please Enter Surname',
                        },
                        {
                            validator: async (rule, value) =>
                                await validateName(rule, value, 'Surname'),
                        },
                    ]}
                >
                    <Input allowClear maxLength={100} />
                </Form.Item>
                <Form.Item
                    label="Type Of SelfEmployment"
                    name="typeOfSelfEmployment"
                    rules={[
                        {
                            validator: async (rule, value) =>
                                await validateName(
                                    rule,
                                    value,
                                    'Type Of SelfEmployment'
                                ),
                        },
                    ]}
                >
                    <Input allowClear maxLength={100} />
                </Form.Item>
                <Form.Item
                    label="Trading Name"
                    name="tradingName"
                    rules={[
                        {
                            required: true,
                            message: 'Please Enter Business Trading Name',
                        },
                        {
                            validator: async (rule, value) =>
                                await validateName(rule, value, 'Trading Name'),
                        },
                    ]}
                >
                    <Input allowClear maxLength={100} />
                </Form.Item>
                <Form.Item label="Individual UTR" name="individualUTR">
                    <Input allowClear maxLength={20} />
                </Form.Item>
            </div>
        )
    }

    const personalDetails = (): React.ReactElement => {
        return (
            <div>
                <Form.Item
                    label="Date Of Birth"
                    name="dateOfBirth"
                    rules={[
                        {
                            validator: async (_, value) =>
                                await validateDate(value),
                        },
                    ]}
                >
                    <Space direction="vertical" size={12}>
                        <DatePicker
                            allowClear
                            onChange={onChange}
                            value={
                                selectedDate.length > 0
                                    ? dayjs(selectedDate)
                                    : null
                            }
                            format="DD/MM/YYYY"
                            className={commonStyles.dateWidth}
                            disabledDate={(current) =>
                                current !== null &&
                                current > dayjs().endOf('day')
                            }
                        />
                    </Space>
                </Form.Item>
                {/* <Form.Item label="NI Number" name="niNumber">
                    <Input allowClear maxLength={9} />
                </Form.Item> */}
                <InputFieldNINumber name="niNumber" form={form} />
                <Form.Item
                    label="Due Date"
                    name="dueDate"
                    rules={[
                        {
                            validator: async (_, value) =>
                                await validateDate(value),
                        },
                    ]}
                >
                    <Space direction="vertical" size={12}>
                        <DatePicker
                            allowClear
                            onChange={onChange}
                            value={
                                selectedDate.length > 0
                                    ? dayjs(selectedDate)
                                    : null
                            }
                            format="DD/MM/YYYY"
                            className={commonStyles.dateWidth}
                            disabledDate={(current) =>
                                current !== null &&
                                current > dayjs().endOf('day')
                            }
                        />
                    </Space>
                </Form.Item>
                <Form.Item
                    label="Mobile Number"
                    name="mobileNumber"
                    rules={[
                        {
                            required: true,
                            message: 'Please Enter Mobile Number',
                        },
                        {
                            pattern: /^\d{10,15}$/,
                            message: 'Mobile Number must be 10-15 digits!',
                        },
                    ]}
                >
                    <Input allowClear maxLength={15} />
                </Form.Item>
                <Form.Item
                    label="Home Number"
                    name="homeNumber"
                    rules={[
                        {
                            pattern: /^\d{10,15}$/,
                            message: 'Home Number must be 10-15 digits!',
                        },
                    ]}
                >
                    <Input allowClear maxLength={15} />
                </Form.Item>
                <Form.Item
                    label="Work Number"
                    name="workNumber"
                    rules={[
                        {
                            pattern: /^\d{10,15}$/,
                            message: 'Work Number must be 10-15 digits!',
                        },
                    ]}
                >
                    <Input allowClear maxLength={15} />
                </Form.Item>
                <Form.Item
                    label="Email Address"
                    name="emailAddress"
                    rules={[
                        {
                            required: true,
                            message: 'Please Enter Email Address',
                        },
                        {
                            pattern:
                                /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                            message: 'Please enter a valid Email Address!',
                        },
                    ]}
                >
                    <Input allowClear maxLength={100} />
                </Form.Item>
                <Form.Item
                    label="Alternative Email Address"
                    name="alternativeEmailAddress"
                    rules={[
                        {
                            pattern:
                                /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                            message: 'Please enter a valid Email Address!',
                        },
                    ]}
                >
                    <Input allowClear maxLength={100} />
                </Form.Item>
            </div>
        )
    }

    const homeAddress = (): React.ReactElement => {
        return (
            <>
                <div>
                    <Form.Item
                        label="Address 1"
                        name="addressOne"
                        rules={[
                            {
                                required: true,
                                message: 'Please Enter Address1',
                            },
                        ]}
                    >
                        <Input allowClear maxLength={200} />
                    </Form.Item>
                    <Form.Item label="Address 2" name="addressTwo">
                        <Input allowClear maxLength={200} />
                    </Form.Item>
                    <Form.Item
                        label="Town"
                        name="homeTown"
                        rules={[
                            {
                                required: true,
                                message: 'Please Enter Town',
                            },
                        ]}
                    >
                        <Input allowClear maxLength={50} />
                    </Form.Item>
                    <Form.Item
                        label="Country"
                        name="homeCountry"
                        initialValue="UNITED KINGDOM"
                        rules={[
                            {
                                required: true,
                                message: 'Please select Country',
                            },
                        ]}
                    >
                        <Select
                            allowClear
                            showSearch
                            placeholder="Please select"
                            onChange={() => {}}
                            optionFilterProp="children"
                            options={countryList?.map(
                                (data: { label: string }) => {
                                    return {
                                        id: data.label,
                                        value: data.label,
                                        label: data.label,
                                    }
                                }
                            )}
                            filterOption={(input, option) =>
                                option?.label
                                    ?.toLowerCase()
                                    .includes(input.toLowerCase()) ?? false
                            }
                        />
                    </Form.Item>

                    <PostCodeInput
                        name="homePostCode"
                        label="Post Code"
                        reuireMessage="Please Enter Post Code"
                        placeHolder={''}
                        setAddressDetails={setAddress}
                    />
                </div>
            </>
        )
    }
    const onFinishFailed = ({ errorFields }: any): void => {
        SetCollapseOne(['1', '2'])
        SetCollapseTwo(['1'])
    }
    return (
        <>
            <div>
                <h2> Individual Registration</h2>
            </div>
            <Card className={commonStyles.card}>
                <Form
                    name="complex-form098"
                    layout={'vertical'}
                    autoComplete="off"
                    form={form}
                    requiredMark={customizeRequiredMark}
                    onFinishFailed={onFinishFailed}
                    onFinish={onsaveInduvidual}
                >
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label="Client Type">
                                <Input disabled value={'Individual'} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Client No" name="clientNumber">
                                <Input disabled />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label="Client Name">
                                <Input disabled />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Business Trading Name"
                                name="businessTradingName"
                            >
                                <Input disabled />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <h3>Basic Information</h3>
                    </Row>
                    <div className={commonStyles.flexDirectionRow}>
                        <div className={soleTraderNewStyles.collapseFirst}>
                            <Collapse
                                activeKey={collapseOne}
                                onChange={collapseOneOnChange}
                                bordered={true}
                            >
                                <Collapse.Panel
                                    key="1"
                                    header="Initial Details"
                                    forceRender
                                >
                                    {initialDetails()}
                                </Collapse.Panel>
                                <Collapse.Panel
                                    key="2"
                                    header="Personal Details"
                                    forceRender
                                >
                                    {personalDetails()}
                                </Collapse.Panel>
                            </Collapse>
                        </div>
                        <div className={soleTraderNewStyles.collapseSecond}>
                            <Collapse
                                activeKey={collapseTwo}
                                onChange={collapseTwoOnChange}
                                bordered={true}
                            >
                                <Collapse.Panel
                                    key="1"
                                    header="Home Address"
                                    forceRender
                                >
                                    {homeAddress()}
                                </Collapse.Panel>
                            </Collapse>
                        </div>
                    </div>
                    &nbsp;
                    <Row gutter={16}>
                        <Col offset={22} span={1}>
                            <Tooltip title="Save Client Details">
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={buttonLoading}
                                >
                                    <SaveOutlined />
                                </Button>
                            </Tooltip>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </>
    )
}

const mapStateToProps = (state: any): SoleTraderNewStateInterface => {
    return {
        categoryDropDownList: state.initial.categoryDropDownList,
        countryList: state.common.countryList,
    }
}

export default connect(mapStateToProps)(InduvidualNew)
